import { useDraggable, useDroppable } from "@dnd-kit/core";
import React from "react";

const DroppableWord = ({ id, sentence }) => {
  // Draggable configuration
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: id.toString(), // Unique ID for each draggable item
  });

  // Droppable configuration
  const { isOver, setNodeRef: setDroppableRef } = useDroppable({
    id: id.toString(), // Use the same ID for droppable and draggable
  });

  // Styling for draggable item
  const style = `p-2 bg-blue-200 rounded-md cursor-pointer inline-block border-2 border-gray-400 ${
    isOver ? "opacity-50" : ""
  }`;

  return (
    <span
      ref={(node) => {
        setNodeRef(node);
        setDroppableRef(node); // Connect droppable reference
      }}
      {...listeners}
      {...attributes}
      className={ sentence.length && style}
    >
      {sentence}
    </span>
  );
};

export default DroppableWord;
